import qs from "query-string";

import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import EntityModel from "../../models/entity";

export default class EntityRepository extends BaseRepository {
  static modelClass = EntityModel;
  modelName = "entity";

  async getRelatedEntities(entityId, params = {}) {
    return await super.query({
      urlPath: `entities/${entityId}/related_entities/?${qs.stringify(params)}`,
    });
  }

  async getRelatedProviders(entityId, params = {}) {
    return await super.query({
      urlPath: `entities/${entityId}/related_providers/?${qs.stringify(params)}`,
    });
  }

  async getRelatedUsers(entityId, params = {}) {
    return await super.query({
      urlPath: `entities/${entityId}/related_users/?${qs.stringify(params)}`,
    });
  }

  async getRelatedContacts(entityId, params = {}) {
    return await super.query({
      urlPath: `entities/${entityId}/related_contacts/?${qs.stringify(params)}`,
    });
  }
}
